export const postFragment = /* GraphQL */ `
  fragment postFragment on Post {
    category
    content
    id
    title
    username
  }
`;
